var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNaTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 24,
    viewBox: "0 0 43 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 24,
    rx: 12,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8564 7.04688V17H17.5303L12.5195 9.32324V17H11.2002V7.04688H12.5195L17.5508 14.7441V7.04688H18.8564ZM25.4053 7.04688L21.2559 17.8545H20.1689L24.3252 7.04688H25.4053ZM30.6621 7.92871L27.3672 17H26.0205L29.8145 7.04688H30.6826L30.6621 7.92871ZM33.4238 17L30.1221 7.92871L30.1016 7.04688H30.9697L34.7773 17H33.4238ZM33.2529 13.3154V14.3955H27.6611V13.3154H33.2529Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaTag);
export default __webpack_public_path__ + "static/media/na-tag.b4e7551678a0da1280e7415df041d6aa.svg";
export { ForwardRef as ReactComponent };